export default "__VITE_ASSET__CM6$bQ$2__";